<h3 fxLayoutAlign="center" class="proposal-detail-title">Histórico MCC</h3>
<div xmlns="http://www.w3.org/1999/html">
      <div class="mcc-history-detail" *ngFor="let itemDetails of mccPhysicalHistoryModel">
        Nome do Usuário: {{itemDetails.name}}<br>
        Login Usuário: {{itemDetails.cpfCnpj | cpfCnpj}}<br>
        Status: {{itemDetails.status}}<br>
        Data do Cadastro: {{itemDetails.createdDate ? (itemDetails.createdDate | date: 'dd/MM/yyyy HH:MM:ss') : '-'}}<br>
        Instituição: {{itemDetails.institution}}<br>
        Service Contract: {{itemDetails.serviceContract}}<br>
        MCC: {{itemDetails.mcc}}<br>
        Ramo de Atividade: {{applyFormatRefexFilterMccDescription(itemDetails.mccDescription)}} <br>
        <br>
        <br>
      </div>
  
</div>
